import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map, List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { connect as connectStaticText } from '../../StaticText/connect'
import { H5 } from '../../Heading/index'
import Link from '../../Link/index'
import { TARGET_BLANK } from '../../Link/constants'
import { getPrimary } from '../../../services/languages/index'
import { getHelpCenterUrl } from '../../../services/url/index'
import { USD } from '../../../services/currency/index'
import { formatPrice } from '../../../services/plans/index'
import { URL_ACCOUNT_INVOICE } from '../../../services/url/constants'

function MyAccountInvoices (props) {
  const { staticText, userAccount, user } = props
  const invoiceHistoryProcessing = userAccount.get('billingInvoiceHistoryProcessing')
  const invoiceHistoryData = userAccount.getIn(['details', 'data', 'billing', 'invoiceHistory'], Map())
  const invoiceHistoryError = !invoiceHistoryData.get('success') && invoiceHistoryData.get('error')
  const invoices = invoiceHistoryData.get('invoices', List())
  const userLanguage = getPrimary(user.getIn(['data', 'language'], List()))
  const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso']) || USD

  const renderDesktopTable = () => {
    if (!invoices || invoices.size < 1) {
      return null
    }

    return (
      <table className="my-account-invoices__table">
        <thead className="my-account-invoices__table-header">
          <tr>
            <th className="my-account-invoices__table-header-cell">
              {staticText.getIn(['data', 'date'])}
            </th>
            <th className="my-account-invoices__table-header-cell">
              {staticText.getIn(['data', 'description'])}
            </th>
            <th className="my-account-invoices__table-header-cell">
              {staticText.getIn(['data', 'servicePeriod'])}
            </th>
            <th className="my-account-invoices__table-header-cell">
              {staticText.getIn(['data', 'paymentMethod'])}
            </th>
            <th className="my-account-invoices__table-header-cell my-account-invoices__table-header-cell--right-align">
              {staticText.getIn(['data', 'subtotal'])}
            </th>
            <th className="my-account-invoices__table-header-cell my-account-invoices__table-header-cell--right-align">
              {staticText.getIn(['data', 'total'])}
            </th>
          </tr>
        </thead>
        <tbody className="my-account-invoices__table-body">
          {invoices.map((invoice) => {
            return (
              <tr className="my-account-invoices__table-row" key={invoice.get('id')}>
                <td className="my-account-invoices__table-cell">
                  <Link
                    directLink
                    to={`${URL_ACCOUNT_INVOICE}?invoiceId=${invoice.get('id')}`}
                    scrollToTop={false}
                    target={TARGET_BLANK}
                    className="my-account-invoices__link"
                  >
                    {invoice.get('date')}
                  </Link>
                </td>
                <td className="my-account-invoices__table-cell">
                  {invoice.get('description')}
                </td>
                <td className="my-account-invoices__table-cell">
                  {invoice.get('servicePeriod')}
                </td>
                <td className="my-account-invoices__table-cell">
                  {invoice.get('paymentMethod')}
                </td>
                <td className="my-account-invoices__table-cell my-account-invoices__table-cell--right-align">
                  {formatPrice(currencyIso, invoice.get('subtotalAmount'), true, null, userLanguage)}
                  <span className="my-account-invoices__tax-amount"> (+{formatPrice(currencyIso, invoice.get('taxAmount'), true, null, userLanguage)} {staticText.getIn(['data', 'tax'])})</span>
                </td>
                <td className="my-account-invoices__table-cell my-account-invoices__table-cell--right-align">
                  {formatPrice(currencyIso, invoice.get('totalAmount'), true, null, userLanguage)}
                </td>
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="6" className="my-account-invoices__table-cell-footer" >
              {staticText.getIn(['data', 'disclaimer'])}
            </td>
          </tr>
        </tfoot>
      </table>
    )
  }

  const renderMobileTable = () => {
    if (!invoices || invoices.size < 1) {
      return null
    }

    return (
      <div className="my-account-invoices__mobile-table">
        {invoices.map((invoice) => {
          return (
            <div className="my-account-invoices__mobile-row" key={invoice.get('id')}>
              <div className="my-account-invoices__mobile-row-column">
                <div className="my-account-invoices__mobile-label">
                  {staticText.getIn(['data', 'date'])}
                </div>
                <div className="my-account-invoices__mobile-value">
                  <Link
                    directLink
                    to={`${URL_ACCOUNT_INVOICE}?invoiceId=${invoice.get('id')}`}
                    scrollToTop={false}
                    className="my-account-invoices__link"
                    target={TARGET_BLANK}
                  >
                    {invoice.get('date')}
                  </Link>
                </div>
                <div className="my-account-invoices__mobile-label">
                  {staticText.getIn(['data', 'description'])}
                </div>
                <div className="my-account-invoices__mobile-value">
                  {invoice.get('description')}
                </div>
                <div className="my-account-invoices__mobile-label">
                  {staticText.getIn(['data', 'servicePeriod'])}
                </div>
                <div className="my-account-invoices__mobile-value">
                  {invoice.get('servicePeriod')}
                </div>
              </div>
              <div className="my-account-invoices__mobile-row-column">
                <div className="my-account-invoices__mobile-label">
                  {staticText.getIn(['data', 'paymentMethod'])}
                </div>
                <div className="my-account-invoices__mobile-value">
                  {invoice.get('paymentMethod')}
                </div>
                <div className="my-account-invoices__mobile-label">
                  {staticText.getIn(['data', 'subtotal'])}
                </div>
                <div className="my-account-invoices__mobile-value">
                  {formatPrice(currencyIso, invoice.get('subtotalAmount'), true, null, userLanguage)}
                  <span className="my-account-invoices__tax-amount"> (+{formatPrice(currencyIso, invoice.get('taxAmount'), true, null, userLanguage)} {staticText.getIn(['data', 'tax'])})</span>
                </div>
                <div className="my-account-invoices__mobile-label">
                  {staticText.getIn(['data', 'total'])}
                </div>
                <div className="my-account-invoices__mobile-value">
                  {formatPrice(currencyIso, invoice.get('totalAmount'), true, null, userLanguage)}
                </div>
              </div>
            </div>
          )
        })}
        <div className="my-account-invoices__mobile-table-footer">
          {staticText.getIn(['data', 'disclaimer'])}
        </div>
      </div>
    )
  }

  const placeholderRows = () => {
    return (
      <React.Fragment>
        <div className="my-account-invoices__placeholder-row" />
        <div className="my-account-invoices__placeholder-row" />
        <div className="my-account-invoices__placeholder-row" />
        <div className="my-account-invoices__placeholder-row" />
      </React.Fragment>
    )
  }

  if (
    !invoiceHistoryProcessing
      && (!invoiceHistoryData
        || invoiceHistoryData.size < 1
        || (invoices.size < 1 && !invoiceHistoryError))
  ) {
    return null
  }

  return (
    <div className="my-account-invoices">
      <H5 className="my-account-invoices__title">{staticText.getIn(['data', 'title'])}</H5>
      {
        invoiceHistoryProcessing
          ? <div className="my-account-invoices__placeholder">
            {placeholderRows()}
          </div>
          : null
      }
      {
        invoiceHistoryError
          ? <p>
            {`${staticText.getIn(['data', 'errorMessageOne'])} `}
            <Link
              to={getHelpCenterUrl(userLanguage)}
              directLink
              target={TARGET_BLANK}
            >
              {staticText.getIn(['data', 'customerSupport'])}
            </Link>
            {` ${staticText.getIn(['data', 'errorMessageTwo'])}`}
          </p>
          : null
      }
      {
        !invoiceHistoryProcessing && !invoiceHistoryError
          ? <React.Fragment>
            <div className="my-account-invoices__table-container">
              {renderDesktopTable()}
            </div>
            <div className="my-account-invoices__mobile-table-container">
              {renderMobileTable()}
            </div>
          </React.Fragment>
          : null
      }
    </div>
  )
}

MyAccountInvoices.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      userAccount: state.userAccount,
    }),
  ),
  connectStaticText({ storeKey: 'myAccountInvoices' }),
)(MyAccountInvoices)
